export enum ComponentSection {
    FAQ = 'Self Service - FAQ',
    SEARCH = 'Self Service - Search',
    CONTACT_LANE = 'Self Service - Contact Lane',
    CES_LANE = 'Self Service - Customer Effort Score Lane',
    FEEDBACK_LANE = 'Self Service - Feedback Lane',
    IMPORTANT_MESSAGE = 'Self Service - Important message',
    QUICK_LINK_LANE = 'Self Service - Quick Link Lane',
    LINK_LANE = 'Self Service - Link Lane',
    SEARCH_BAR = 'Self Service - CS Search Bar',
    BREADCRUMBS = 'Self Service - Breadcrumbs Lane',
    MESSENGER = 'Self Service - Messenger',
    EMAIL_FEEDBACK_FORM = 'Self Service - Email feedback form',
    MY_SETTLEMENTS = 'Self Service - Mijn verrekeningen',
}

export enum ComponentType {
    ACCORDION = 'Accordion',
    REGULAR_BUTTON = 'regular Button',
    STAR_RATING = '5 star rating',
    THUMB_UP_DOWN = 'thumb up/down',
    SEARCH_FIELD = 'Search field',
    MESSENGER_LINK = 'messenger link',
}

export enum ComponentSubType {
    BUTTON = 'button',
    BACK_BUTTON = 'back button',
    LINK = 'link',
}

export enum ComponentAdditional {
    MESSENGER = 'Messenger',
    FLOATER = 'Floater',
}
